<template>
  <b-modal
    id="classNotificationModal"
    centered
    title="Danh sách thông báo"
    size="xl"
    body-class="position-static"
    hide-footer
    @shown="onShown"
  >
    <b-row class="mt-2">
      <b-col cols="12">
        <vue-good-table
          :columns="columns"
          :rows="dataSources"
          :pagination-options="paginationOptions"
          :line-numbers="true"
        >
          <div
            slot="emptystate"
            style="text-align: center; font-weight: bold"
          >
            Không có bản ghi nào !
          </div>
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span
              v-if="props.column.field === 'createdBy'"
              class="text-nowrap"
            >
              <!--              <b-avatar-->
              <!--                :src="props.row.avatar"-->
              <!--                class="mx-1"-->
              <!--              />-->
              <span class="text-nowrap">{{ props.row.createdBy }}</span>
            </span>
            <!-- Column: Common -->
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Hiển thị 1 đến </span>
                <b-form-select
                  v-model="itemsPerPage"
                  :options="itemsPerPageOptions"
                  class="mx-1"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })"
                />
                <span class="text-nowrap">của {{ props.total }} bản ghi</span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="itemsPerPage"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                />
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-col>
    </b-row>

    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="isLoading"
      no-wrap
    />
  </b-modal>
</template>

<script>
import {
  BCol, BFormSelect, BModal, BOverlay, BPagination, BRow, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import { showErrorToast } from '@/utils/notification'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'ClassNotification',
  components: {
    BModal,
    BCol,
    BRow,
    BFormSelect,
    BOverlay,
    BPagination,
    // BAvatar,
    VueGoodTable,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    classId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      itemsPerPage: 20,
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'Tiêu đề',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            placeholder: 'Nhập tiêu đề',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Nội dung',
          field: 'description',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            placeholder: 'Nhập nội dung',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Người tạo',
          field: 'createdBy',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            placeholder: 'Nhập người tạo',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Ngày tạo',
          field: 'createdAt',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            placeholder: 'Nhập ngày tạo',
          },
          sortable: true,
          thClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      dataSources: 'notification/classNotifications',
    }),
    paginationOptions() {
      return {
        enabled: true,
        perPage: this.itemsPerPage,
      }
    },
  },
  methods: {
    ...mapActions({
      getNotificationsByClass: 'notification/getNotificationsByClass',
    }),
    async onShown() {
      await this.getDataSourcesFromStore()
    },
    async getDataSourcesFromStore() {
      this.isLoading = true
      try {
        await this.getNotificationsByClass({ classId: this.classId })
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
